export const GameDetailDependencyTypes = {
  GameDetailPlayerApiDataTransformer: Symbol.for('GameDetailPlayerApiDataTransformer'),
  GameDetailRepository: Symbol.for('GameDetailRepository'),
  GameDetailTimelineService: Symbol.for('GameDetailTimelineService'),
  GameDetailFetcherService: Symbol.for('GameDetailFetcherService'),
  GameDetailLayoutStoreCommand: Symbol.for('GameDetailLayoutStoreCommand'),
  GameDetailLayoutPresenter: Symbol.for('GameDetailLayoutPresenter'),
  GameDetailPresenter: Symbol.for('GameDetailPresenter'),
  GameDeletionService: Symbol.for('GameDeletionService'),
  GameDetailGameDeletionModalPresenter: Symbol.for('GameDetailGameDeletionModalPresenter'),
  GameDetailAdditionalInformationComponentsResolver: Symbol.for('GameDetailAdditionalInformationComponentsResolver'),
  GameRescheduleModalPresenter: Symbol.for('GameRescheduleModalPresenter'),
  GameRescheduleModalService: Symbol.for('GameRescheduleModalService'),
  GameRescheduleModalStoreQuery: Symbol.for('GameRescheduleModalStoreQuery'),
  GameRescheduleModalStoreCommand: Symbol.for('GameRescheduleModalStoreCommand'),
  GameRescheduleFormFactory: Symbol.for('GameRescheduleFormFactory'),
  GameStatisticsPresenter: Symbol.for('GameStatisticsPresenter'),
  GameStatisticsStoreQuery: Symbol.for('GameStatisticsStoreQuery'),
  GameStatisticsStoreCommand: Symbol.for('GameStatisticsStoreCommand'),
  GamePlayersListPresenter: Symbol.for('GamePlayersListPresenter'),
  GameDetailPlayerListStoreQuery: Symbol.for('GameDetailPlayerListStoreQuery'),
  GameDetailPlayerListStoreCommand: Symbol.for('GameDetailPlayerListStoreCommand'),
  GameDetailApiService: Symbol.for('GameDetailApiService'),
  GameDetailStoreQuery: Symbol.for('GameDetailStoreQuery'),
  GameDetailStoreCommand: Symbol.for('GameDetailStoreCommand'),
  GameUpdateSubscriptionStartDateModalPresenter: Symbol.for('GameUpdateSubscriptionStartDateModalPresenter'),
  GameUpdateSubscriptionStartDateModalService: Symbol.for('GameUpdateSubscriptionStartDateModalService'),
  GameUpdateSubscriptionStartDateModalStoreQuery: Symbol.for('GameUpdateSubscriptionStartDateModalStoreQuery'),
  GameUpdateSubscriptionStartDateModalStoreCommand: Symbol.for('GameUpdateSubscriptionStartDateModalStoreCommand'),
  GameSubscriptionStartDateFormFactory: Symbol.for('GameSubscriptionStartDateFormFactory'),
  GameUpdateUnveilingResultsDateModalPresenter: Symbol.for('GameUpdateUnveilingResultsDateModalPresenter'),
  GameUpdateUnveilingResultsDateModalService: Symbol.for('GameUpdateUnveilingResultsDateModalService'),
  GameUpdateUnveilingResultsDateModalStoreQuery: Symbol.for('GameUpdateUnveilingResultsDateModalStoreQuery'),
  GameUpdateUnveilingResultsDateModalStoreCommand: Symbol.for('GameUpdateUnveilingResultsDateModalStoreCommand'),
  GameUpdateUnveilingResultsDateFormFactory: Symbol.for('GameUpdateUnveilingResultsDateFormFactory'),
};
